//#region src/components/HighlightSearch/helpers/splitStringBySubstring.ts
var e = (e, t) => {
	let n = e.toLowerCase(), r = t.toLowerCase(), i = [], a = 0;
	if (t === "" || e === "") return [e];
	for (; a < n.length;) {
		let o = n.indexOf(r, a);
		if (o === -1) {
			i.push(e.substring(a));
			break;
		}
		o !== 0 && i.push(e.substring(a, o)), o === 0 && t.length < e.length && i.push(""), i.push(e.substring(o, o + t.length)), a = o + t.length;
	}
	return i;
};
//#endregion
export { e as splitStringBySubstring };
